'use client';

import { signIn, signOut, useSession, SessionProvider } from 'next-auth/react';
import { Box, Button, Skeleton, Typography } from '@mui/material';

function AuthPanel() {
  const { data: session, status } = useSession();

  if (status === 'loading') {
    return (
      <Box display="flex" alignItems="center" gap={2} p={2}>
        <Skeleton variant="rectangular" width={80} height={36} />
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" gap={2} p={2}>
      {session?.user?.email && (
        <Typography variant="body1">Signed in as {session.user.email}</Typography>
      )}
      {session ? (
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => signOut({ callbackUrl: '/' })}
        >
          Logout
        </Button>
      ) : (
        <>
          <Typography variant="body1" sx={{ flexGrow: 1 }}>
            You are not logged in. Please login.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => signIn('cognito')}
          >
            Login
          </Button>
        </>
      )}
    </Box>
  );
}

export default function AuthPanelWrapper() {
  return (
    <SessionProvider>
      <AuthPanel />
    </SessionProvider>
  );
}
